/* eslint-disable jira/filename-case */
import { expVal } from '@atlassian/jira-feature-experiments';

const jiraTimelineHarmonisationM2RelayProvider = {
	get(): boolean {
		return expVal('timeline_harmonisation_m2', 'isEnabled', false);
	},
};

export default jiraTimelineHarmonisationM2RelayProvider;
